import { render } from "./InventorySystem.vue?vue&type=template&id=3466637b&ts=true"
import script from "./InventorySystem.vue?vue&type=script&lang=ts"
export * from "./InventorySystem.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__